/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedReceiptStatusList } from '../models/PaginatedReceiptStatusList';
import type { PatchedReceiptStatus } from '../models/PatchedReceiptStatus';
import type { ReceiptStatus } from '../models/ReceiptStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsReceiptStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedReceiptStatusList
     * @throws ApiError
     */
    public clientsReceiptStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedReceiptStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-receipt-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ReceiptStatus
     * @throws ApiError
     */
    public clientsReceiptStatusCreate({
        requestBody,
    }: {
        requestBody: ReceiptStatus,
    }): CancelablePromise<ReceiptStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-receipt-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ReceiptStatus
     * @throws ApiError
     */
    public clientsReceiptStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this receipt status.
         */
        id: number,
    }): CancelablePromise<ReceiptStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-receipt-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ReceiptStatus
     * @throws ApiError
     */
    public clientsReceiptStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this receipt status.
         */
        id: number,
        requestBody: ReceiptStatus,
    }): CancelablePromise<ReceiptStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-receipt-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ReceiptStatus
     * @throws ApiError
     */
    public clientsReceiptStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this receipt status.
         */
        id: number,
        requestBody?: PatchedReceiptStatus,
    }): CancelablePromise<ReceiptStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-receipt-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsReceiptStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this receipt status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-receipt-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
